module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/monitor-pc/white.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/monitor-pc/white.jpg
// module id = 595
// module chunks = 0